import type { FC } from 'react';
import { ConfirmDeleteModal } from '../../../../Components/Modals/ConfirmDelete/ConfirmDeleteModal';
import type { ProdutoDetalhado } from '../../hooks/useProdutosCampanha';
import type { Campaign, IRowData, OfferBlockOption, OfferFormState } from '../../types/offer.types';
import { ModalBulkEditOfferWrap } from '../ModalBulkEditOfferWrap';
import ModalProgramarCampanha from '../ModalProgramarCampanha';
import { ModalRegisterOfferWrap } from '../ModalRegisterOfferWrap';

interface OfertasModalsWrapperProps {
  // Register Modal
  showRegisterModal: boolean;
  onCloseRegister: () => void;
  onConfirmRegister: () => Promise<any>;
  campaignId: string;
  storeIds: string[];
  offerBlocks: OfferBlockOption[];
  isEditMode: boolean;
  selectedOfferId: string | null;
  initialProducts?: ProdutoDetalhado[];
  initialOffer?: Record<string, any>;
  initialOfferGroup?: string | null;
  onSetOferta: (oferta: OfferFormState) => void;

  // Bulk Edit Modal
  showBulkEditModal: boolean;
  onCloseBulkEdit: () => void;
  onConfirmBulkEdit: () => void;
  selectedOffers: IRowData[];

  // Delete Modal
  showDeleteModal: boolean;
  onConfirmDelete: () => Promise<void>;
  onCancelDelete: () => void;
  deleteTitle?: string;
  deleteMessage: string;

  // Schedule Modal
  showScheduleModal: boolean;
  onCloseSchedule: () => void;
  onConfirmSchedule: () => Promise<void>;
  campaign: Campaign;
}

export const OfertasModalsWrapper: FC<OfertasModalsWrapperProps> = ({
  // Register Modal
  showRegisterModal,
  onCloseRegister,
  onConfirmRegister,
  campaignId,
  storeIds,
  offerBlocks,
  isEditMode,
  selectedOfferId,
  initialProducts,
  initialOffer,
  initialOfferGroup,
  onSetOferta,

  // Bulk Edit Modal
  showBulkEditModal,
  onCloseBulkEdit,
  onConfirmBulkEdit,
  selectedOffers,

  // Delete Modal
  showDeleteModal,
  onConfirmDelete,
  onCancelDelete,
  deleteTitle = 'Excluir oferta da campanha',
  deleteMessage,

  // Schedule Modal
  showScheduleModal,
  onCloseSchedule,
  onConfirmSchedule,
  campaign,
}) => (
  <>
    {/* Modal de Registro/Edição de Oferta */}
    <ModalRegisterOfferWrap
      show={showRegisterModal}
      confirmOferta={onConfirmRegister}
      closeOferta={onCloseRegister}
      id={campaignId}
      idsLojas={storeIds}
      blocosOfertas={offerBlocks}
      setOferta={onSetOferta}
      editOferta={isEditMode}
      ofertaId={selectedOfferId}
      initialProducts={initialProducts}
      initialOffer={initialOffer}
      initialOfferGroup={initialOfferGroup}
    />

    {/* Modal de Edição em Massa */}
    <ModalBulkEditOfferWrap
      show={showBulkEditModal}
      onClose={onCloseBulkEdit}
      onConfirm={onConfirmBulkEdit}
      selectedOffers={selectedOffers}
      id={campaignId}
      idsLojas={storeIds}
      blocosOfertas={offerBlocks}
    />

    {/* Modal de Confirmação de Exclusão */}
    <ConfirmDeleteModal open={showDeleteModal} onConfirm={onConfirmDelete} onCancel={onCancelDelete} title={deleteTitle} message={deleteMessage} />

    {/* Modal de Programação de Campanha */}
    <ModalProgramarCampanha show={showScheduleModal} campanha={campaign} onCancel={onCloseSchedule} onConfirm={onConfirmSchedule} />
  </>
);

OfertasModalsWrapper.displayName = 'OfertasModalsWrapper';
